import { Instagram, Mail, MessageCircle } from "lucide-react";
import { IMAGES, JOIN_URL, NAV_LINKS } from "../../data/content";

export const Footer = () => {
  return (
    <footer className="relative bg-[#020617] border-t border-slate-800/60 px-5 sm:px-8 py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between gap-10">
        <div className="max-w-sm">
          <a href="#top" className="flex items-center gap-2.5 mb-4" data-testid="footer-logo-link">
            <img src={IMAGES.logo} alt="MindBodyLife.pro logo" className="h-8 w-8 object-contain" />
            <span className="font-display font-bold text-base text-white">
              MINDBODYLIFE<span className="text-cyan-400">.pro</span>
            </span>
          </a>
          <p className="text-sm text-slate-500 leading-relaxed">
            India's Holistic Health &amp; Wellness Transformation Platform. Workouts. Nutrition. Mindset.
            Lifestyle. Breathing. Expert Guidance.
          </p>
          <div className="flex items-center gap-4 mt-6">
            <a href={JOIN_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="text-slate-500 hover:text-cyan-400 transition-colors duration-200">
              <Instagram size={18} />
            </a>
            <a href={JOIN_URL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="footer-social-whatsapp" className="text-slate-500 hover:text-cyan-400 transition-colors duration-200">
              <MessageCircle size={18} />
            </a>
            <a href="mailto:hello@mindbodylife.pro" aria-label="Email" data-testid="footer-social-email" className="text-slate-500 hover:text-cyan-400 transition-colors duration-200">
              <Mail size={18} />
            </a>
          </div>
        </div>

        <div className="flex flex-wrap gap-x-10 gap-y-6">
          <div>
            <h4 className="font-mono-brand text-xs uppercase tracking-widest text-slate-500 mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-slate-400 hover:text-cyan-400 transition-colors duration-200" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono-brand text-xs uppercase tracking-widest text-slate-500 mb-4">Get Started</h4>
            <a
              href={JOIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-full bg-cyan-500/10 border border-cyan-500/30 px-4 py-2 text-xs font-bold uppercase tracking-wide text-cyan-300"
              data-testid="footer-cta-join"
            >
              Start For ₹1/Day
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-slate-600">© {new Date().getFullYear()} MindBodyLife.pro. All rights reserved.</p>
        <p className="text-xs text-slate-600 font-mono-brand uppercase tracking-widest">365 Days. ₹365. One Healthier You.</p>
      </div>
    </footer>
  );
};
